module.exports = __webpack_public_path__ + "static/img/DSC_001.70177899.png";